import { render, staticRenderFns } from "./ProveedorForm.vue?vue&type=template&id=50f4bba2&"
import script from "./ProveedorForm.vue?vue&type=script&lang=ts&"
export * from "./ProveedorForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports